import { date } from 'quasar'

export default function formatDate(d, id_user_language_selected) {
  if (d) {
    let format = ''

    switch (id_user_language_selected) {
      case 1:
      case 3:
        format = 'MM-DD-YYYY HH:mm'
        break
      default:
        format = 'DD/MM/YYYY HH:mm'
        break
    }

    return date.formatDate(d, format)
  }
}